var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 text-sm"},[_c('div',{staticClass:"flex flex-row justify-between py-2 rounded"},[_c('div',{staticClass:"flex flex-row items-center space-x-1"},[_c('div',{staticClass:"items-center"},[_c(_vm.icon,{tag:"component",staticClass:"w-4 h-4",class:{
                        'text-red-600': _vm.isFail === true,
                        'text-green-600': _vm.isFail === false,
                        'text-primary-700': _vm.isFail === null,
                    }})],1),_c('span',{domProps:{"innerHTML":_vm._s(_vm.transformation)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }